export default __webpack_public_path__ + "static/media/cs_icon_03_on.ce191147.png";